
const API = 'https://shopify-api.nowutalk.ai/api/v1/agent/check-limit-exceeded?store_url='

export const getServiceStatus = async (domain: string) => {
    const response = await fetch(API + domain);
    if(!response.ok) {
        return false
    }
    const data = await response.json()
    if(data.exceeded) {
        return false
    }
    return true
}

